import { useEffect, useState } from 'react';
import nucleusViewportTokens from '@connectedhomes/nucleus/tokens/viewport.json';

const { NEGATIVE_INFINITY, POSITIVE_INFINITY } = Number;
const breakpoints = Object.values(nucleusViewportTokens.viewport).reduce(
  (acc, item) => {
    const isMobileViewport = item.type === 'mobile';
    const isTabletViewport = item.type === 'tablet';
    const isDesktopViewport = item.type === 'desktop';
    const itemIntValue = parseInt(item.value, 10);

    return {
      ...acc,
      ...(isMobileViewport && {
        mobile: Math.max(
          parseInt(acc.mobile, 10) || NEGATIVE_INFINITY,
          itemIntValue
        )
      }),
      ...(isTabletViewport && {
        tablet: Math.max(
          parseInt(acc.tablet, 10) || NEGATIVE_INFINITY,
          itemIntValue
        )
      }),
      ...(isDesktopViewport && {
        desktop: Math.min(
          parseInt(acc.desktop, 10) || POSITIVE_INFINITY,
          itemIntValue
        )
      })
    };
  },
  {}
);

export const useResponsiveContext = () => {
  const isMobileMql = window.matchMedia(
    `only screen and (max-width: ${breakpoints.tablet - 1}px)`
  );
  const isTabletMql = window.matchMedia(
    `only screen and 
     (min-width: ${breakpoints.tablet}px) and 
     (max-width: ${breakpoints.desktop - 1}px)`
  );
  const isDesktopMql = window.matchMedia(
    `only screen and (min-width: ${breakpoints.desktop}px)`
  );

  const [responsive, setResponsive] = useState({
    isMobile: isMobileMql.matches,
    isTablet: isTabletMql.matches,
    isDesktop: isDesktopMql.matches
  });

  useEffect(() => {
    const onMediaChange = /* istanbul ignore next -- @preserve */ () => {
      setResponsive({
        isMobile: isMobileMql.matches,
        isTablet: isTabletMql.matches,
        isDesktop: isDesktopMql.matches
      });
    };

    isMobileMql.onchange = onMediaChange;
    isTabletMql.onchange = onMediaChange;
    isDesktopMql.onchange = onMediaChange;

    return () => {
      isMobileMql.onchange = null;
      isTabletMql.onchange = null;
      isDesktopMql.onchange = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return responsive;
};
